import { getStatusColor } from '@/utils';
import { Layer, Source } from 'react-map-gl/maplibre';

export function ExternalPeopleSource({ id, data, visibility = 'visible' }) {
  return (
    <Source id={id} type="geojson" data={data}>
      <Layer
        id={`${id}-shape-layer`}
        type="symbol"
        layout={{
          'icon-image': 'ir3-circle',
          'icon-allow-overlap': true,
          'icon-size': ['interpolate', ['linear'], ['zoom'], 5, 0.125, 12, 1],
          visibility,
        }}
        paint={{
          'icon-color': [
            'match',
            ['get', 'status'],
            'UNAVAILABLE',
            getStatusColor('UNAVAILABLE'),
            'ASSIGNED',
            getStatusColor('ASSIGNED'),
            'ATTENDED',
            getStatusColor('ATTENDED'),
            'AVAILABLE',
            getStatusColor('AVAILABLE'),
            'EMERGENCY',
            getStatusColor('EMERGENCY'),
            'UNKNOWN',
            getStatusColor('UNKNOWN'),
            getStatusColor('DEFAULT'),
          ],
          'icon-halo-color': '#fff',
          'icon-halo-width': 1,
        }}
      />
      <Layer
        id={`${id}-symbol-layer`}
        type="symbol"
        layout={{
          'icon-image': 'ir3-external-person',
          'icon-allow-overlap': true,
          'icon-size': ['interpolate', ['linear'], ['zoom'], 5, 0.075, 12, 0.6],
          visibility,
        }}
        paint={{
          'icon-color': '#fff',
        }}
      />
    </Source>
  );
}
